import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import CidadeController from "@/shared/controllers/cidade/cidadeController";
import EstadoController from "@/shared/controllers/estado/estadoController";
import TransportadoraController from "@/shared/controllers/transportadora/transportadoraController";
import FiltroGerenciarTransportadora from "@/shared/view-models/Filtros/FiltroGerenciarTransportadora";
import Tools from "@/shared/services/tools";
import {mask} from 'vue-the-mask'
import AccountLoged from "@/shared/mixins/AccountLoged";




export default {
  name:'GerenciamentoTransportadoras',
  directives: {mask},
  components: { 
    gCard,
    gForm
   
  }, 

  props: { },
  mixins:[AccountLoged],

  mounted () {
    if(!this.hasClaim('Gerenciamento-Transportadora')) {
      this.$router.push('/sem-acesso')
    }
    this.EmpresaArray = this.$store.state.EmpresaArray;

    this.EstadoArray = EstadoController.getEstados().EstadosArray;

   },

  updated () { },

  data () {
    return { 
      CidadeArray: [],
      popup: false,
      EstadoArray:[],
      cnpjMascara: [],
      TransportadoraArray: [],
      transportadoraSelecionada: null,
      objFiltro: new FiltroGerenciarTransportadora,
      TransportadorasInfoArray: [],
      Colunas : [
        {field: 'cnpjMascara', header: 'CNPJ'},
        {field: 'nomeTransportadora', header: 'Nome da Transportadora'},
        {field: 'nomeReduzido', header: 'Nome Reduzido'},
        {field: 'endereco', header: 'Endereço'},
        {field: 'cidadeEstado', header: 'Cidade / Estado'}
    ],


    }
  },

  methods: { 
    novaTransportadora() {
      this.$router.push(`/gerar-nova-transportadora`)
    },
    abrePopup () {
      this.popup=true
    },
    fechaPopup(){
      this.popup = false
    },
    buscarNomeTransportadoras(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        TransportadoraController.getTransportadoras(event, this.objFiltro.UnidadeId).requisicao
          .then((res => {
            this.TransportadoraArray = res.data.data
          }))
      }, 2000);
    },
    limpafiltro(){
      this.objFiltro = new FiltroGerenciarTransportadora
      this.transportadoraSelecionada = ''
    },
    buscarcidade(){
      this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + 'Cidade/getbyestado',
          data: {
              id: this.objFiltro.EstadoId
          }
        })
          .then((response) => {
            this.CidadeArray = response.data.data


          })
          .catch(() => {
          });
    },
    popularDropDownEstado(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Estado/get',
      })
        .then((response) => {
          this.EstadoArray = response.data.data
  
        })
        .catch(() => {
        });
    },
    setCidade () {
      let cidade = this.CidadeArray.find((Element) => Element.id == this.objFiltro.CidadeId)
      let estado = this.EstadoArray.find((Element) => Element.id == cidade.estadoId)
  
      if(estado)
        this.objFiltro.EstadoId = estado.id
  
    },
    buscarCidadeSemEstado(event){

      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.CidadeArray = CidadeController.getByCidadeEstado(event).CidadeArray;
      }, 1000);
    },
    verificaCPNJ() {
      if(this.objFiltro.cnpj.length == 18) {
        var cnpjValido = Tools.validaCNPJ(this.objFiltro.cnpj)
        if (! cnpjValido) {
          this.$toast.add({ severity: 'error', summary: 'CNPJ invalido', life: 5000 });
        }
      }  
    },
    buscarTransportadoras(){
      if(this.objFiltro.cnpj != null || this.objFiltro.cnpj != undefined) {
        let cnpjRegex = this.objFiltro.cnpj.replace(/[\D]/gm, '')
        this.objFiltro.cnpj = cnpjRegex
      }
      if(this.transportadoraSelecionada != ''){      
        this.objFiltro.TransportadoraId = this.transportadoraSelecionada
      }
      TransportadoraController.getTransportadorasByFiltro(this.objFiltro).requisicao
        .then((res => {
          this.TransportadorasInfoArray = res.data.data
          this.cnpjMascara = []
          this.TransportadorasInfoArray.forEach((Element) => 
            Element['cnpjMascara'] = Element.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,"$1.$2.$3/$4-$5")
          )
        }))
    },
  },

  computed: { }, 

};